import { ISubmissionFieldsResponse } from '@publishing-engine/submission-service/src/usecases/submission-fields/types';

export function getMissingFieldFieldsResponse(
  fieldsRecord: ISubmissionFieldsResponse
): { fields: ISubmissionFieldsResponse; hasMissingFields: boolean } {
  const fields: ISubmissionFieldsResponse = {};

  Object.keys(fieldsRecord).forEach(fieldName => {
    const curr = fieldsRecord[fieldName]!;
    const value = curr.value;

    if (curr.editing.isEditable && value === null) {
      if (
        'externalFieldDependency' in curr.formFieldDefinition.params &&
        curr.externalDependency?.pathValue ===
          curr.formFieldDefinition.params.externalFieldDependency?.value
      ) {
        fields[fieldName] = curr;
      } else if (curr.formFieldDefinition.params.validations.required) {
        fields[fieldName] = curr;
      }
    }
  });

  return {
    hasMissingFields: Object.keys(fields).length > 0,
    fields
  };
}
